import { useQuery, UseQueryResult } from "react-query";
import { useSession } from "@supabase/auth-helpers-react";
import { assert } from "#/utils/general";
import { getStripeProducts } from "#next/pages/api/stripe/products.action";
import { GetProductsResponse } from "#next/pages/api/stripe/products.api";


export const useStripeProducts = (): UseQueryResult<GetProductsResponse["products"]> => {
  const session = useSession();
  const userId = session?.user?.id;
  const queryResult = useQuery<GetProductsResponse["products"]>([ "stripe-products", userId ], async () => {
    assert(!!userId, "User must be logged in to fetch stripe products");
    const result = await getStripeProducts();
    return result;
  }, {
    enabled: !!userId
  });

  return queryResult;
};
